import { useEffect, useRef } from 'react';

import { useEditor } from 'craft/hooks/useEditor';
import { createColumnOperations } from 'craft/resolvers/Columns/ColumnOperations';

interface useColumnOperationsProps {
  parentNodeId: string;
}

export const useColumnOperations = ({ parentNodeId }: useColumnOperationsProps) => {
  const editor = useEditor();

  const actions = useRef(createColumnOperations(parentNodeId, editor));

  useEffect(() => {
    actions.current = createColumnOperations(parentNodeId, editor);
  }, [parentNodeId]);

  return actions.current;
};
